<template lang="pug">
v-sheet.d-flex.flex-column.full-height(color="transparent")

  v-list(dark)
    v-list-item(two-line)
      template(v-if="!mini")
        v-list-item-content.flex-1
          the-logotype
        v-btn(
          to="/events-search"
          icon
          small
        ).mr-1
          v-icon(:size="18") $izoom
      v-btn(
        icon
        small
        @click="toggleMini"
      )
        v-icon {{ icon }}

    template(v-if="$route.meta.hasSearch")
      template(v-if="!$drawer.subdrawer && !mini")
        template(v-if="isSearchOpen")
          v-list-item
            v-list-item-content
              search-drawer

  ev-drawer-content-menu(:mini-drawer="mini")

  .d-flex.flex-column.gap-8.mt-auto.px-4.pb-4.body-2.redesignControlsBackground--text(
    v-if="!mini"
  )
    .d-flex.flex-wrap.gap-10.align-center.mb-1(v-if="$conf.isVrn")
      app-tooltip(max-width="250")
        template(#reason) Cкачать мобильное приложение для участников
        a(:href="$conf.APPLICATION_IOS" target="_blank")
          v-icon(size="38" color="redesignControlsBackground") $iapple-app-store
      app-tooltip(max-width="250")
        template(#reason) Cкачать мобильное приложение для участников
        a(:href="$conf.APPLICATION_ANDROID" target="_blank")
          v-icon(size="30" color="redesignControlsBackground") $iru-store
    router-link.opacity-90(
      :to="$conf.PRIVACY_POLICY"
    ) Политика конфиденциальности
    router-link.opacity-90(
      :to="$conf.USER_AGREEMENT"
    ) Пользовательское соглашение
</template>

<script>
import TheLogotype from './TheLogotype.vue';
import SearchDrawer from '../SearchDrawer.vue';
import EvDrawerContentMenu from './EvDrawerContentMenu.vue';

export default {
  components: {
    TheLogotype,
    SearchDrawer,
    EvDrawerContentMenu,
  },
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSearchOpen: false,
    };
  },
  computed: {
    icon() {
      if (this.mini) {
        return 'mdi-arrow-collapse-right';
      }

      return 'mdi-arrow-collapse-left';
    },
    username() {
      if (this.$user.isAuthenticated) {
        return this.$user.data.profile?.username || this.$user.data.organizer?.full_name || this.$user.data?.username;
      }

      return 'Гость';
    },
  },
  methods: {
    toggleMini() {
      this.$emit('update:mini', !this.mini);
    },
    toggleSearch() {
      this.isSearchOpen = !this.isSearchOpen;
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/');
    },
  },
};
</script>
